import { Component, OnInit } from '@angular/core';
import { GlobalEventServiceService } from '@services/global-event-service.service';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-checkbox-cell-renderer',
  template: `
  <div style="height: 50px; padding: 4px;">
  <mat-checkbox [checked]="data?.selected"(change)="change($event)"></mat-checkbox>
  </div>
`
  //templateUrl: './checkbox-cell-renderer.component.html'
})
export class CheckboxCellRendererComponent implements OnInit {

  data: any;

  eventName = 'assigned';

  constructor(
    private eventService: GlobalEventServiceService
  ) { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.data = params.data;

    const colDefParams = params?.colDef?.cellRendererParams;
    if (colDefParams && colDefParams.eventName) {
      this.eventName = colDefParams.eventName;
    }
  }

  change($event: any) {
    this.eventService.sendEvent(this.eventName, {
      item: this.data,
      checked: $event.checked
    });
  }
}
